"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Column = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const deliveryItem_1 = __importDefault(require("../deliveryItem"));
const list_1 = __importDefault(require("../list"));
const listGroup_1 = __importDefault(require("../listGroup"));
const listItem_1 = __importDefault(require("../listItem"));
const paymentItem_1 = __importDefault(require("../paymentItem"));
const CommunityIcon_1 = __importDefault(require("./CommunityIcon"));
const Styles = __importStar(require("./styles"));
const Column = (_a) => {
    var { listBlocFooterLink, isHorizontal, onLinkClick, hideTitleMobile = false, paymentsNames } = _a, props = __rest(_a, ["listBlocFooterLink", "isHorizontal", "onLinkClick", "hideTitleMobile", "paymentsNames"]);
    const GroupParent = listBlocFooterLink.length > 1 ? listGroup_1.default : Styles.DefaultContainer;
    const handleClick = (e, href, loggedIn) => {
        if (onLinkClick && loggedIn) {
            e.preventDefault();
            onLinkClick(href);
        }
    };
    return ((0, jsx_runtime_1.jsx)(GroupParent, Object.assign({}, props, { children: listBlocFooterLink.map(({ blockFooterLinkTitle, deliveryIcons, listFooterLink, paymentIcons, icon }, listIndex) => ((0, jsx_runtime_1.jsxs)(list_1.default, { label: blockFooterLinkTitle, isHorizontal: isHorizontal, icon: icon, hideTitleMobile: hideTitleMobile, children: [listFooterLink &&
                    listFooterLink.map(({ footerLinkText, footerLinkTitle, footerLinkRedirection, icon, loggedIn, target }, itemIndex) => footerLinkTitle && ((0, jsx_runtime_1.jsx)(listItem_1.default, { isHorizontal: isHorizontal, children: (0, jsx_runtime_1.jsxs)(Styles.ItemLink, { title: footerLinkTitle, href: footerLinkRedirection, premium: blockFooterLinkTitle === 'Premium' && itemIndex === 1, target: target, onClick: (e) => handleClick(e, footerLinkRedirection, loggedIn), children: [icon && (0, jsx_runtime_1.jsx)(CommunityIcon_1.default, { name: footerLinkText }), (0, jsx_runtime_1.jsx)(Styles.ItemLinkText, { hideTitleMobile: hideTitleMobile, children: footerLinkText })] }) }, itemIndex))), (0, jsx_runtime_1.jsx)(paymentItem_1.default, { icons: paymentIcons, humanNames: paymentsNames }), (0, jsx_runtime_1.jsx)(deliveryItem_1.default, { icons: deliveryIcons })] }, listIndex))) })));
};
exports.Column = Column;
exports.default = exports.Column;
